import service from './request';
export default {
    
    //充电费率模式-列表
    getChargePriceGroup(params){
        return service.post('/api/getChargePriceGroup', params);
    },    
    //充电费率模式-新增
    addChargePriceGroup(params){
        return service.post('/api/addChargePriceGroup', params);
    },
    //充电费率模式-修改
    editChargePriceGroup(params){
        return service.post('/api/editChargePriceGroup', params);
    },
    //充电费率模式-删除
    delChargePriceGroup(params){
        return service.post('/api/delChargePriceGroup', params);
    },

    //删除充值优惠
    payPriceDelete(params){
        return service.get('/admin/payPriceDelete', {params:params});
    },

    //获取所有桩群
    pileGroupAllList(params){
        return service.get('/admin/pileGroupAllList', {params:params});
    },

    //获取分账列表 各个商户分账明细
    getReconciliations(params){
        return service.post('/api/getReconciliations', params);
    }, 
    //获取商户提现列表-准备审核
    getCheckCashReconciliations(params){
        return service.post('/api/getCheckCashReconciliations', params);
    },
    //获取商户提现详情-准备审核
    getCheckCashReconciliationDetails(params){
        return service.post('/api/getCheckCashReconciliationDetails', params);
    },
    //提现审核
    checkCashOneReconciliation(params){
        return service.post('/api/checkCashOneReconciliation', params);
    },
    //直接修改提现状态，手动完成
    updateCashOneReconciliationStatus(params){
        return service.post('/api/updateCashOneReconciliationStatus', params);
    },
    //重新出发代付请求
    replacePay(params){
        return service.post('/api/ReDaiFu', params);
    },

    //代付过程查询
    replacePayQuery(params){
        return service.post('/api/CashQuery', params);
    },

    //获取某条提现相关的分账明细
    getReconciliationsByCash(params){
        return service.post('/api/getReconciliationsByCash', params);
    },

    //获取商户提现账户列表
    companyBankList(params){
        return service.post('/api/companyBankList', params);
    },
    //商户提现账户审核,激活 禁止
    checkCompanyBank(params){
        return service.post('/api/checkCompanyBank', params);
    },

    //备用金管理
    //获取分账列表
    fenZhangList(params){
        return service.post('/api/fenZhangList', params);
    },
    //设置分账账户
    saveCabSettings(params){
        return service.post('/api/saveCabSettings', params);
    },
    //获取分账的信息
    getCabSettings(params){
        return service.post('/api/getCabSettings', params);
    },
    //发起分账
    fenZhang(params){
        return service.post('/api/fenZhang', params);
    },

    //流量费用列表
    getMobileFeeList(params){
        return service.post('/api/getMobileFeeList', params);
    },

    //绑定厂商/物业
    bindCompany(params){
        return service.post('/admin/bindCompany', params);
    },

    //优惠券列表
    couponList(params){
        return service.get('/admin/couponList', {params:params});
    },
    //优惠券新增
    addCoupon(params){
        return service.post('/admin/addCoupon', params);
    },
    //优惠券上下架
    couponStatus(params){
        return service.post('/admin/couponStatus', params);
    },
    //优惠券审核
    couponAudit(params){
        return service.post('/admin/couponAudit', params);
    },
    //优惠券支付
    couponPay(params){
        return service.post('/admin/couponPay', params, {headers: {'Content-Type': 'multipart/form-data'}} );  //参数中有文件类型，使用formData
    },
    //优惠券详情
    couponDetail(params){
        return service.get('/admin/couponDetail', {params:params});
    },
    //优惠券记录列表
    couponRecordList(params){
        return service.get('/admin/couponRecordList', {params:params});
    },
    //导入分配优惠券
    importAllocation(params){
        return service.post('/admin/importAllocation', params, {headers: {'Content-Type': 'multipart/form-data'}}); //参数中有文件类型，使用formData
    },

    //统计报表充电订单退款
    rechargeOrderRefund(params){
        return service.post('/api/rechargeOrderRefund', params);
    },


    //========================================商户端接口
    //获取分账列表 商户自己
    getReconciliationsCompany(params){
        return service.post('/api/getReconciliationsCompany', params);
    }, 
    //商户提现申请前置信息
    cashReconciliationsCompany(params){
        return service.post('/api/cashReconciliationsCompany', params);
    }, 
    //商户发起提现申请
    requestCashReconciliationsCompany(params){
        return service.post('/api/requestCashReconciliationsCompany', params);
    }, 
    //获取商户提现列表
    getCheckCashReconciliationsCompany(params){
        return service.post('/api/getCheckCashReconciliationsCompany', params);
    }, 
    //获取商户提现详情
    getCheckCashReconciliationDetailsCompany(params){
        return service.post('/api/getCheckCashReconciliationDetailsCompany', params);
    }, 
    //获取某条提现相关的分账明细
    getReconciliationsByCashCompany(params){
        return service.post('/api/getReconciliationsByCashCompany', params);
    }, 

    //修改密码
    updatePasswordCompany(params){
        return service.post('/company/updatePassword', params);
    },
    //流量费用列表
    getMobileFeeListCompany(params){
        return service.post('/api/getMobileFeeListCompany', params);
    },    

    //========================================商户端接口


}


